import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormGroup } from '../FormGroup';

/**
 * A select allows a user to select a value from a series of options.
 */
const Select = (props) => {
  const { children, className, label, id, small, large, rounded, ...otherProps } = props;
  const formGroupProps = { label, id };
  const inputProps = { id, ...otherProps };
  const classNames = classnames('form-select', className, { 'select-sm': small, 'select-lg': large, 'select-rounded': rounded });

  return (
    <FormGroup {...formGroupProps}>
      <select {...inputProps} className={classNames}>
        {children}
      </select>
    </FormGroup>
  );
};

Select.propTypes = {
  /** Primary content. */
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  /** Additional classes. */
  className: PropTypes.string,
  /** Optional Label to display along side the Select. */
  label: PropTypes.string,
  /** Input id */
  id: PropTypes.string,
  /** A Select can have small size. */
  small: PropTypes.bool,
  /** A Select can have large size. */
  large: PropTypes.bool,
  /** A Select can have rounded borders. */
  rounded: PropTypes.bool,
};

Select.defaultProps = {
  className: '',
  label: '',
  id: '',
  small: false,
  large: false,
  rounded: false,
};

export { Select };
